export default __webpack_public_path__ + "static/icon-benefits-home-livro-aadb6336fe504996359600d153438ce0.png";